function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCameraEmptyDisabled = function SvgCameraEmptyDisabled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7 5.706h-.036L8.511.871a1.482 1.482 0 0 0-2.001 0 1.27 1.27 0 0 0 0 1.877l3.152 2.958H8.88c-1.537 0-2.784 1.17-2.784 2.612v10.448c0 1.443 1.247 2.612 2.784 2.612h15.312c.613 0 1.18-.186 1.64-.501l5.688 5.336a1.482 1.482 0 0 0 2.001 0 1.27 1.27 0 0 0 0-1.877l-6.545-6.141v-.033L24.19 15.55v.033l-7.743-7.265h.035zm10.49 6.09V8.318h-3.705L17.7 5.706h6.49c1.537 0 2.784 1.17 2.784 2.612v1.12l4.877-2.615c.668-.358 1.518-.14 1.9.486.12.197.183.42.183.648v11.17c0 .49-.288.918-.714 1.141l-5.672-5.322 3.602 1.931v-6.67l-4.176 2.239v1.962zM8.88 8.318h3.566l11.136 10.448H8.88Z",
    style: {
      strokeWidth: 1.47088
    }
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: "10.6667px",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      fillOpacity: 1,
      stroke: "none"
    },
    x: 7.161,
    y: 39.558
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 7.161,
    y: 39.558,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "10.6667px",
      fontFamily: "sans-serif",
      InkscapeFontSpecification: "'sans-serif Bold'"
    }
  }, "CAM")));
};
export default SvgCameraEmptyDisabled;